export { useMenuGroupHeader_unstable as useMenuGroupHeader } from '@fluentui/react-menu';
